'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createElementFromHTML = createElementFromHTML;
function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  return div.firstChild;
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/dom-utils.js
// module id = 2
// module chunks = 0 1 2 3